import React, { useState, useEffect } from "react";
import * as dateFns from "date-fns";
import { useTranslation } from "react-i18next";

import Modal from "../../common/Modal";
import Button from "../../common/FormFields/Button";
import CustomSelect from "../../common/FormFields/Select";
import {
  getStartOfWorkDay,
  timestampToIso,
} from "../../../services/helpers";

const DeleteAppointment = (props) => {
  const {
    selectedTimeslot,
    recurrenceRule,
    currentDate,
    deleteAppointmentModalIsOpen,
    setTimeslotRequest,
    toggleDeleteAppointmentModal,
    startOverwriteTimeslot,
    currentAppointment,
    isDayPage,
  } = props;
  const { t } = useTranslation();
  const [chosenAppointment, setChosenAppointment] = useState(null);
  const [currentAppointments, setCurrentAppointments] = useState([]);

  useEffect(() => {
    setCurrentAppointments(
      selectedTimeslot?.appointments
        .filter((item) => item.status === "pending")
        .map((item) => {
          return {
            label: `${dateFns.format(new Date(item.startDate), "HH:mm")} - ${dateFns.format(new Date(item.endDate), "HH:mm")}`,
            value: String(item.startDate),
          };
        }) || [],
    );
  }, [selectedTimeslot]);

  useEffect(() => {
    const initialChosenAppointmentValue = isDayPage ? currentAppointments.find(appointment => Number(appointment.value) === currentAppointment?.startDate) : null;

    if (currentAppointments.length === 1) {
      setChosenAppointment(currentAppointments[0]);
    } else {
      setChosenAppointment(initialChosenAppointmentValue);
    }
  }, [currentAppointments, currentAppointment?.startDate, isDayPage]);

  const getHoursOnDateException = () => {
    const appointmentToDelete = selectedTimeslot?.appointments.find(
      (appointment) =>
        appointment.startDate.toString() === chosenAppointment.value,
    );

    const from = appointmentToDelete.startDate;
    const to = appointmentToDelete.endDate;
    const date = getStartOfWorkDay(currentDate);

    return {
      from: timestampToIso(from),
      to: timestampToIso(to),
      date: timestampToIso(date),
    };
  };

  const getTimeslotRequestBody = () => {
    const {
      resourceId,
      timeslotId,
      donorType,
      bloodTiter,
      appointmentType,
      startDate,
      endDate,
      ruleDescription,
      initialExceptionDates = [],
      initialExceptionHoursOnDates = [],
      initialExceptionRules,
    } = selectedTimeslot;

    return {
      resourceId,
      donorType,
      bloodTiter,
      appointmentTypeId: appointmentType.appointmentTypeId,
      startDate,
      endDate,
      timeslotId,
      ...(recurrenceRule && { rule: recurrenceRule }),
      ruleDescription,
      exceptionDates: initialExceptionDates,
      exceptionHoursOnDates: [
        ...initialExceptionHoursOnDates,
        getHoursOnDateException(),
      ], // Appointment exception
      exceptionRules: initialExceptionRules,
    };
  };

  const handleClose = () => {
    toggleDeleteAppointmentModal();
    setChosenAppointment(null);
  };

  const handleSubmit = () => {
    startOverwriteTimeslot();
    const data = getTimeslotRequestBody();
    setTimeslotRequest(data, selectedTimeslot.appointmentType.duration);
    toggleDeleteAppointmentModal();
    setChosenAppointment(null);
  };

  return (
    <>
      <Modal
        isModalOpen={deleteAppointmentModalIsOpen}
        handleModalClose={handleClose}
        {...props}
      >
        <div className="modal-header">
          <h2 className="modal-title">
            {t("configuration.settings.deleteAppointmentModal.header")}
          </h2>
          <button className="modal-close" onClick={handleClose}>
            <span className="icon-close" />
          </button>
        </div>
        <div className="modal-body modal-content">
          {chosenAppointment && (
            <div className="modal-msg">
              {t("configuration.settings.deleteAppointmentModal.body1")}
            </div>
          )}
          {currentAppointments.length > 1 && (
            <div className="form-group">
              <CustomSelect
                label={t(
                  "configuration.settings.bookAppointmentModal.selectAppointmentTime",
                )}
                data={currentAppointments}
                value={chosenAppointment}
                onChange={setChosenAppointment}
                isSearchable={true}
              />
            </div>
          )}
        </div>
        <div className="modal-footer light">
          <div className="inputs-group">
            <div className="inputs-group-item">
              <Button
                type="button"
                text={t("common.cancel")}
                onClick={handleClose}
              />
            </div>
            <div className="inputs-group-item">
              <Button
                btnClassName={`btn-primary`}
                type="button"
                text={t("common.delete")}
                onClick={handleSubmit}
                disabled={!chosenAppointment}
              />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DeleteAppointment;
